import Chip from '@mui/material/Chip';
import clsx from 'clsx';
import React from 'react';
import { LOADING_TEXT } from 'src/constants';
import { createFullDateString } from 'src/helpers';
import { TLogger } from 'src/redux/services/logger';
import { CustomTypography } from '../custom/CustomTypography';
import { Card, ICardProps } from '../shared/Card';
import styles from './EventLogCard.module.css';

export interface ICardEventLogProps extends ICardProps {
  items: TLogger[];
  index: number;
  openModal: (value: TLogger) => void;
  isUserSpecific?: boolean;
}

const CardEventLogComponent: React.FC<ICardEventLogProps> = (props) => {
  const { items, index, isUserSpecific, openModal } = props;
  const event = items[index] || {};

  function translateEvent(code: string) {
    switch (code) {
      case 'USER_LOGIN_SUCCESS':
        return 'Успешный вход пользователя';
      case 'BILLING_DEDUCT':
        return 'Списание средств с лицензионного счета';
      case 'BILLING_UPDATE_API_KEY':
        return 'Обновление API ключа для биллинга';
      default:
        return code;
    }
  }

  return (
    <Card
      {...props}
      cardId={event?.id?.toString()}
      onClick={() => openModal(event)}
      content={
        <div className={styles.info}>
          <div className={styles.chipContainer}>
            <Chip label={translateEvent(event?.event)} className={clsx('text-12', styles.chip)} />
          </div>
          <div className={styles.infoRow}>
            <CustomTypography className={clsx('text-12', styles.infoText)}>
              Дата и время:
            </CustomTypography>
            <CustomTypography className="text-12">
              {createFullDateString(new Date(event?.date)) || LOADING_TEXT}
            </CustomTypography>
          </div>
          {!isUserSpecific && (
            <div className={styles.infoRow}>
              <CustomTypography className={clsx('text-12', styles.infoText)}>
                Пользователь:
              </CustomTypography>
              <CustomTypography className="text-12">{event?.user_id || '-'}</CustomTypography>
            </div>
          )}
          <div className={styles.infoRow}>
            <CustomTypography className={clsx('text-12', styles.infoText)}>
              Приложение:
            </CustomTypography>
            <CustomTypography className="text-12">{event?.client_id || '-'}</CustomTypography>
          </div>
          {event.details && (
            <div className={styles.infoRow}>
              <CustomTypography className={clsx('text-12', styles.infoText)}>
                Детали:
              </CustomTypography>
              <CustomTypography className="text-12">
                {JSON.stringify(event.details)}
              </CustomTypography>
            </div>
          )}
        </div>
      }
    />
  );
};

export const CardEventLog = CardEventLogComponent;
